import React from 'react';
import { UPDATE_MAILBOX_MUTATION } from '../../../api/mutations';
import { ICreateMailboxData } from '../forms/CreateMailboxForm';
import { useMutation } from '@apollo/client';
import { MAILBOXES } from '@/api/queries';

const useUpdateMailbox = () => {
    const [ updateMailbox ] = useMutation(UPDATE_MAILBOX_MUTATION, {
        refetchQueries: [MAILBOXES]
    })


    const handleUpdateMailbox = async (values: ICreateMailboxData, setError: (error: string) => void) => {

        const req = await updateMailbox({ variables: values });

        if (req.data?.updateMailbox?.message) {
            if (req.data.updateMailbox.__typename == "ErrorType") return setError(req.data?.updateMailbox?.message);
            return req.data?.updateMailbox?.message
        }

        req.errors && setError(req.errors.toString())
    }

    return {
        updateMailbox: handleUpdateMailbox
    }
}

export default useUpdateMailbox;